<!-- eslint-disable -->
<template>
    <div class="minimal-auth-wrapper">
        <div class="auth-container">
            <!-- Logo Section -->
            <div class="logo-section" v-if="app.logo">
                <b-img :src="app.logo" alt="Logo" class="brand-logo" />
            </div>

            <!-- Main Card -->
            <div class="login-card">
                <!-- Loading State - Verificando -->
                <div v-if="isVerifying" class="text-center">
                    <div class="login-header">
                        <h1 class="login-title">Verificando enlace...</h1>
                    </div>

                    <div class="spinner-container">
                        <b-spinner
                            style="width: 3rem; height: 3rem"
                            label="Verificando..."
                            variant="primary"
                        />
                    </div>

                    <p class="text-muted mt-3">
                        Por favor espera mientras verificamos tu enlace de
                        acceso.
                    </p>
                </div>

                <!-- Confirmation State - Mostrar datos del usuario y botón confirmar -->
                <div v-else-if="showConfirmation" class="text-center">
                    <div class="login-header">
                        <h1 class="login-title">¡Hola, {{ userName }}!</h1>
                        <p class="login-subtitle">
                            Estás a punto de iniciar sesión con el correo:
                        </p>
                    </div>

                    <div class="email-display">
                        <feather-icon icon="MailIcon" size="20" />
                        <strong>{{ userEmail }}</strong>
                    </div>

                    <b-button
                        variant="primary"
                        block
                        class="submit-btn"
                        :disabled="isConfirming"
                        @click="handleConfirm"
                    >
                        <b-spinner v-if="isConfirming" small class="mr-2" />
                        {{
                            isConfirming ? "Confirmando..." : "Confirmar acceso"
                        }}
                    </b-button>

                    <div class="info-text mt-3">
                        <feather-icon icon="InfoIcon" size="16" />
                        <span>¿No fuiste tú? Ignora este enlace.</span>
                    </div>
                </div>

                <!-- Success State - Redirigiendo -->
                <div v-else-if="verificationSuccess" class="text-center">
                    <div class="login-header">
                        <h1 class="login-title success-title">
                            ¡Acceso exitoso!
                        </h1>
                    </div>

                    <div class="success-alert">
                        <div class="alert-icon">
                            <feather-icon icon="CheckCircleIcon" size="32" />
                        </div>
                        <div class="alert-content">
                            <strong>Bienvenido de vuelta</strong>
                            <p class="mb-0">
                                Serás redirigido al portal en breve...
                            </p>
                        </div>
                    </div>

                    <div class="redirect-indicator">
                        <b-spinner small class="mr-2" />
                        <span>Redirigiendo...</span>
                    </div>
                </div>

                <!-- Error State -->
                <div v-else-if="verificationError" class="text-center">
                    <div class="login-header">
                        <h1 class="login-title error-title">
                            Enlace inválido o expirado
                        </h1>
                    </div>

                    <div class="error-alert">
                        <div class="alert-icon">
                            <feather-icon icon="AlertCircleIcon" size="32" />
                        </div>
                        <div class="alert-content">
                            {{ errorMessage }}
                        </div>
                    </div>

                    <b-button
                        variant="primary"
                        block
                        class="submit-btn mb-3"
                        @click="goToLogin"
                    >
                        <feather-icon icon="ArrowLeftIcon" class="mr-1" />
                        Volver al login
                    </b-button>

                    <b-button
                        v-if="$route.query.email"
                        variant="outline-secondary"
                        block
                        class="back-btn"
                        :disabled="isRequestingNew"
                        @click="requestNewLink"
                    >
                        <feather-icon icon="MailIcon" class="mr-1" />
                        {{
                            isRequestingNew
                                ? "Enviando..."
                                : "Solicitar nuevo enlace"
                        }}
                    </b-button>
                </div>
            </div>

            <!-- Payment Methods -->
            <div class="payment-methods">
                <p class="payment-label">Métodos de pago</p>
                <div class="payment-images">
                    <b-img
                        :src="imgFooter"
                        alt="Tarjetas"
                        class="payment-img"
                    />
                    <b-img
                        :src="imgPayPal"
                        alt="PayPal"
                        class="payment-img-paypal"
                    />
                </div>
            </div>

            <!-- Footer -->
            <div class="page-footer">
                <feather-icon icon="LockIcon" size="14" />
                <span>Conexión segura</span>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import useJwt from "@/auth/jwt/useJwt";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import {
    BAlert,
    BButton,
    BCard,
    BCardText,
    BCardTitle,
    BCol,
    BImg,
    BLink,
    BRow,
    BSpinner,
} from "bootstrap-vue";

export default {
    components: {
        BRow,
        BCol,
        BButton,
        BCard,
        BCardTitle,
        BLink,
        BCardText,
        BSpinner,
        BAlert,
        ToastificationContent,
        BImg,
    },
    data() {
        return {
            isVerifying: true,
            showConfirmation: false,
            isConfirming: false,
            verificationSuccess: false,
            verificationError: false,
            errorMessage: "",
            isRequestingNew: false,
            userName: "",
            userEmail: "",
            magicLinkToken: "",
            app: {
                banner: "",
                name: "",
                logo: "",
            },
            imgFooter: require("@/assets/images/logo/footer-card.png"),
            imgPayPal: require("@/assets/images/logo/paypal.png"),
        };
    },
    created() {
        this.$http
            .get("/get-env")
            .then((response) => {
                this.app.banner = response.data.data.app_banner;
                this.app.name = response.data.data.app_name;
                this.app.logo = response.data.data.app_logo;
            })
            .catch((error) => {
                console.log(error);
            });
    },
    mounted() {
        this.verifyMagicLink();
    },
    methods: {
        async verifyMagicLink() {
            const { token } = this.$route.params;

            if (!token) {
                this.handleVerificationError("Token no encontrado");

                return;
            }

            // Guardar el token para usarlo en el paso de confirmación
            this.magicLinkToken = token;

            try {
                // Paso 1: Validar el token (GET - solo valida, no autentica)
                const response = await useJwt.verifyMagicLink(token);

                if (response.data.valid) {
                    // Token válido - mostrar pantalla de confirmación
                    this.userName = response.data.userName || "Usuario";
                    this.userEmail = response.data.email || "";
                    this.isVerifying = false;
                    this.showConfirmation = true;
                } else {
                    // Token inválido
                    this.handleVerificationError(
                        response.data.error || "Enlace inválido o expirado"
                    );
                }
            } catch (error) {
                console.error("Magic link validation error:", error);
                this.handleVerificationError(
                    error.response?.data?.error ||
                        error.response?.data?.message ||
                        "El enlace ya fue utilizado o ha expirado"
                );
            }
        },

        async handleConfirm() {
            this.isConfirming = true;

            try {
                // Limpiar cualquier token previo
                localStorage.removeItem("accessToken");
                localStorage.removeItem("refreshToken");
                localStorage.removeItem("userData");

                // Paso 2: Confirmar y obtener token de acceso (POST)
                const response = await useJwt.confirmMagicLink(
                    this.magicLinkToken
                );

                // Verificar que la respuesta tenga los datos necesarios
                if (
                    !response.data ||
                    !response.data.accessToken ||
                    !response.data.userData
                ) {
                    throw new Error("Respuesta del servidor incompleta");
                }

                // Configurar tokens y datos del usuario
                useJwt.setToken(response.data.accessToken);

                if (response.data.refreshToken) {
                    useJwt.setRefreshToken(response.data.refreshToken);
                }

                if (response.data.userData) {
                    localStorage.setItem(
                        "userData",
                        JSON.stringify(response.data.userData)
                    );
                }

                if (response.data.paraIsp) {
                    localStorage.setItem(
                        "paraIsp",
                        JSON.stringify(response.data.paraIsp)
                    );
                }

                // Actualizar habilidades
                if (response.data.userData && response.data.userData.ability) {
                    this.$ability.update(response.data.userData.ability);
                }

                // Mostrar éxito
                this.showConfirmation = false;
                this.verificationSuccess = true;

                // Mostrar toast de éxito
                this.showToast(
                    response.data.message || "Acceso exitoso",
                    "success",
                    "CheckCircleIcon"
                );

                // Redirigir después de 2 segundos
                setTimeout(() => {
                    const { redirect } = this.$route.query;
                    this.$router.push(
                        redirect && redirect.startsWith("/") ? redirect : "/"
                    );
                }, 2000);
            } catch (error) {
                console.error("Magic link confirmation error:", error);

                // Limpiar localStorage en caso de error
                localStorage.removeItem("accessToken");
                localStorage.removeItem("refreshToken");
                localStorage.removeItem("userData");

                this.showConfirmation = false;
                this.handleVerificationError(
                    error.response?.data?.error ||
                        error.response?.data?.message ||
                        "Error al iniciar sesión. El enlace puede haber expirado."
                );
            } finally {
                this.isConfirming = false;
            }
        },

        handleVerificationError(message) {
            this.isVerifying = false;
            this.showConfirmation = false;
            this.verificationError = true;
            this.errorMessage = message;
        },

        goToLogin() {
            this.$router.push({ name: "auth-login" });
        },

        async requestNewLink() {
            const { email } = this.$route.query;

            if (!email) {
                this.$swal({
                    title: "Error",
                    text: "No se pudo determinar el email. Por favor vuelva al login.",
                    icon: "error",
                });

                return;
            }

            this.isRequestingNew = true;

            try {
                await useJwt.sendMagicLink(email);

                this.showToast(
                    "Nuevo enlace enviado a tu email",
                    "success",
                    "MailIcon"
                );

                // Redirigir a página de confirmación
                this.$router.push({
                    name: "magic-link-sent",
                    params: { email },
                });
            } catch (error) {
                this.$swal({
                    title: "Error",
                    text:
                        error.response?.data?.message ||
                        "Error enviando el enlace",
                    icon: "error",
                });
            } finally {
                this.isRequestingNew = false;
            }
        },

        showToast(message, variant, icon) {
            this.$toast({
                component: ToastificationContent,
                props: {
                    title: message,
                    variant,
                    icon,
                },
            });
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@core/scss/vue/pages/page-auth.scss";

// Minimal Auth Wrapper
.minimal-auth-wrapper {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fafbfc;
    padding: 2rem;
}

// Auth Container
.auth-container {
    width: 100%;
    max-width: 420px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

// Logo Section
.logo-section {
    margin-bottom: 3rem;

    .brand-logo {
        max-width: 180px;
        max-height: 180px;
        display: block;
    }
}

// Login Card
.login-card {
    width: 100%;
    background: #ffffff;
    border: 1px solid #e1e4e8;
    border-radius: 8px;
    padding: 2rem;
    margin-bottom: 2rem;
}

// Login Header
.login-header {
    margin-bottom: 2rem;

    .login-title {
        font-size: 1.5rem;
        font-weight: 600;
        color: #24292e;
        margin: 0 0 0.5rem 0;
        letter-spacing: -0.02em;

        &.success-title {
            color: #28a745;
        }

        &.error-title {
            color: #d73a49;
        }
    }

    .login-subtitle {
        font-size: 0.875rem;
        color: #586069;
        margin: 0;
        line-height: 1.5;
    }
}

// Spinner Container
.spinner-container {
    padding: 2rem 0;
}

// Email Display
.email-display {
    background-color: #f6f8fa;
    border: 1px solid #e1e4e8;
    border-radius: 6px;
    padding: 1rem;
    margin-bottom: 1.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;

    svg {
        color: #0366d6;
    }

    strong {
        color: #0366d6;
        font-size: 0.9rem;
    }
}

// Success Alert
.success-alert {
    background-color: #dcffe4;
    border: 1px solid #34d058;
    border-radius: 6px;
    padding: 1.5rem;
    margin-bottom: 1.5rem;

    .alert-icon {
        margin-bottom: 0.75rem;

        svg {
            color: #28a745;
        }
    }

    .alert-content {
        strong {
            color: #24292e;
            display: block;
            margin-bottom: 0.25rem;
        }

        p {
            font-size: 0.875rem;
            color: #586069;
        }
    }
}

// Error Alert
.error-alert {
    background-color: #ffeef0;
    border: 1px solid #f97583;
    border-radius: 6px;
    padding: 1.5rem;
    margin-bottom: 1.5rem;

    .alert-icon {
        margin-bottom: 0.75rem;

        svg {
            color: #d73a49;
        }
    }

    .alert-content {
        font-size: 0.875rem;
        color: #86181d;
    }
}

// Redirect Indicator
.redirect-indicator {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #586069;
    font-size: 0.875rem;
}

// Submit Button
.submit-btn {
    height: 44px;
    padding: 0.625rem 1rem;
    font-size: 0.875rem;
    font-weight: 600;
    color: #ffffff !important;
    background-color: #24292e;
    border: 1px solid rgba(27, 31, 35, 0.15);
    border-radius: 6px;
    transition: background-color 0.2s ease;

    &:hover:not(:disabled) {
        background-color: #1b1f23;
        border-color: rgba(27, 31, 35, 0.15);
    }

    &:focus {
        box-shadow: 0 0 0 3px rgba(36, 41, 46, 0.1);
    }

    &:active:not(:disabled) {
        background-color: #181b1f;
    }

    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }
}

// Back Button
.back-btn {
    height: 44px;
    padding: 0.625rem 1rem;
    font-size: 0.875rem;
    font-weight: 600;
    color: #24292e;
    background-color: #fafbfc;
    border: 1px solid #d1d5da;
    border-radius: 6px;
    transition: background-color 0.2s ease;

    &:hover:not(:disabled) {
        background-color: #f3f4f6;
        border-color: #d1d5da;
    }

    &:focus {
        box-shadow: 0 0 0 3px rgba(36, 41, 46, 0.1);
    }

    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }
}

// Info Text
.info-text {
    padding: 0.75rem;
    background-color: #f6f8fa;
    border: 1px solid #e1e4e8;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    font-size: 0.75rem;
    color: #586069;
    line-height: 1.4;

    svg {
        flex-shrink: 0;
        color: #0366d6;
    }
}

// Payment Methods
.payment-methods {
    width: 100%;
    padding: 1.5rem 0;
    text-align: center;

    .payment-label {
        font-size: 0.75rem;
        color: #6a737d;
        margin: 0 0 1rem 0;
        text-transform: uppercase;
        letter-spacing: 0.05em;
        font-weight: 600;
    }

    .payment-images {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 0.75rem;

        .payment-img {
            max-width: 260px;
            height: auto;
            opacity: 0.7;
        }

        .payment-img-paypal {
            max-width: 80px;
            height: auto;
            opacity: 0.7;
        }
    }
}

// Page Footer
.page-footer {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.375rem;
    font-size: 0.75rem;
    color: #6a737d;

    svg {
        color: #28a745;
    }
}

// Responsive Design
@media (max-width: 576px) {
    .minimal-auth-wrapper {
        padding: 1rem;
    }

    .auth-container {
        max-width: 100%;
    }

    .logo-section {
        margin-bottom: 2rem;

        .brand-logo {
            max-width: 100px;
            max-height: 100px;
        }
    }

    .login-card {
        padding: 1.5rem;
    }

    .login-header {
        margin-bottom: 1.5rem;

        .login-title {
            font-size: 1.25rem;
        }
    }

    .payment-methods {
        padding: 1rem 0;

        .payment-images {
            .payment-img {
                max-width: 220px;
            }
        }
    }
}

@media (max-width: 360px) {
    .login-card {
        padding: 1.25rem;
    }

    .payment-images {
        .payment-img {
            max-width: 200px;
        }

        .payment-img-paypal {
            max-width: 70px;
        }
    }
}
</style>
